var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFilter = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#8798ad",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 4,
  y1: 21,
  x2: 4,
  y2: 14
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 4,
  y1: 10,
  x2: 4,
  y2: 3
})), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
  x1: 12,
  y1: 21,
  x2: 12,
  y2: 12
})), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
  x1: 12,
  y1: 8,
  x2: 12,
  y2: 3
})), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
  x1: 20,
  y1: 21,
  x2: 20,
  y2: 16
})), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
  x1: 20,
  y1: 12,
  x2: 20,
  y2: 3
})), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
  x1: 1,
  y1: 14,
  x2: 7,
  y2: 14
})), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
  x1: 9,
  y1: 8,
  x2: 15,
  y2: 8
})), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
  x1: 17,
  y1: 16,
  x2: 23,
  y2: 16
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFilter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/filter.26ec5e0d.svg";
export { ForwardRef as ReactComponent };